import styled from 'styled-components';

const BaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  padding: 0 16px;
`;

export const StickyContainer = styled.div`
  position: sticky;
  top: 0px;
`;

export const Container = styled.div`
  padding-bottom: 16px;
`;

export const TopWrapper = styled(BaseWrapper)`
  border-radius: 0 24px 0 0;
`;

export const BottomWrapper = styled(BaseWrapper)`
  background: #fff;
  margin-top: 16px;
`;

export const ProductOfferBox = styled.div`
  background: #fff;
  padding: ${({ $padding }) => ($padding ? $padding : '16px')};
  margin-top: 16px;
  border-radius: 16px;
  border: 1px solid #f1f1f1;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.08);

  > div {
    margin: 0;
    padding: 0;
    border: none;
  }

  .discount-progressive {
    border-radius: 8px;
    &-text {
      font-size: 13px;
    }

    .product-tooltip {
      &-invisible {
        margin-left: -19px;
      }
    }
  }
`;
